import { useTranslation } from 'react-i18next';

function SeasonRecordComponent({record, type}) {
    const { t } = useTranslation();
    // let recordString = '';

    // if(type === 'batter') {
    //     recordString += (record['basicStat_gameCnt'] || 0);
    //     // recordString += '경기 ';
    //     recordString += t('game') + " ";

    //     recordString += (record['basicStat_tpa'] || 0);
    //     // recordString += '타석 ';
    //     recordString += t('pa') + ' ';

    //     recordString += `${record['avg']}/${record['obp']}/${record['slg']}`;
    // } else {
    //     recordString += (record['basicStat_gameCnt'] || 0);
    //     // recordString += '경기 ';
    //     recordString += t('game') + " ";
    //     recordString += (record['win'] || 0);
    //     // recordString += '승 ';
    //     recordString += t('win') + " ";
    //     recordString += (record['lose'] || 0);
    //     // recordString += '패 ';
    //     recordString += t('lose') + " ";
    //     recordString += (record['save'] || 0);
    //     // recordString += '세이브 ';
    //     recordString += t('save') + " ";
    //     recordString += (record['hold'] || 0);
    //     // recordString += '홀드';
    //     recordString += t('hold');
    // }

    return (
        <>
            {/* <div className="dataRow">
                {recordString}
            </div> */}
            <div className="dataTable">
                <table>
                    {
                        type === 'batter' ?
                        <>  
                            <thead>
                                <tr>
                                    <th>{t('hit')}</th>
                                    <th>{t('hr')}</th>
                                    <th>{t('rbi')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{record['basicStat_hit']}</td>
                                    <td>{record['basicStat_hr']}</td>
                                    <td>{record['basicStat_rbi']}</td>
                                </tr>
                                <tr>
                                    <th>{t('so')}</th>
                                    <th>{t('bb')}</th>
                                    <th>{t('sb')}</th>
                                </tr>
                                <tr>
                                    <td>{record['basicStat_so']}</td>
                                    <td>{record['basicStat_bb'] ? record['basicStat_bb']+record['basicStat_ibb'] : ''}</td>
                                    <td>{record['basicStat_sbSucc']}</td>
                                </tr>
                            </tbody>
                        </> :
                        <>
                            <thead>
                                <tr>
                                    <th>{t('ip')}</th>
                                    <th>ERA</th>
                                    <th>FIP</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{record['ip']}</td>
                                    <td>{record['era']}</td>
                                    <td>{record['fip']}</td>
                                </tr>
                                <tr>
                                    <th>{t('so')}</th>
                                    <th>{t('bb')}</th>
                                    <th>WHIP</th>
                                </tr>
                                <tr>
                                    <td>{record['basicStat_so']}</td>
                                    <td>{record['basicStat_bb'] ? record['basicStat_bb']+record['basicStat_ibb'] : ''}</td>
                                    <td>{record['whip']}</td>
                                </tr>
                            </tbody>
                        </>
                    }
                </table>
            </div>
        </>
    )
}

export default SeasonRecordComponent;